<!-- 采购订单付款 -->
<template>
    <div class="business-content-main">
        <div class="bread-nav">
            <breadcrumb></breadcrumb>
        </div>
        <div class="tab-item-ctn">
            <div class="search-ctn">
                <div class="search-ctn-left">
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.EntpCusName.IsShow">
                            {{ searchShowSets.EntpCusName.Title }}
                        </div>
                        <el-select
                            v-if="searchShowSets.EntpCusName.IsShow"
                            class="search-item"
                            size="small"
                            v-model="searchData.Keyword"
                            remote
                            filterable
                            allow-create
                            :placeholder="searchShowSets.EntpCusName.Placeholder"
                            :remote-method="searchSupplier"
                            v-select-scroll-more="searchSupplierLoad"
                            @keyup.enter.native="handleSearch"
                        >
                            <el-option v-for="item in supplierOptions" :key="item.EntpCusId" :label="item.EntpCusName" :value="item.EntpCusName"> </el-option>
                        </el-select>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.OrderCode.IsShow">
                            {{ searchShowSets.OrderCode.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.OrderCode.IsShow"
                            class="search-item"
                            size="small"
                            v-model="searchData.OrderCode"
                            :placeholder="searchShowSets.OrderCode.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.Sources.IsShow">
                            {{ searchShowSets.Sources.Title }}
                        </div>
                        <el-autocomplete
                            class="search-item"
                            v-if="searchShowSets.Sources.IsShow"
                            v-model.trim="searchData.Sources"
                            :fetch-suggestions="querySource"
                            :placeholder="searchShowSets.Sources.Placeholder"
                            clearable
                            size="small"
                            @keyup.enter.native="handleSearch"
                        ></el-autocomplete>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.SaleOrderCode.IsShow">
                            {{ searchShowSets.SaleOrderCode.Title }}
                        </div>
                        <el-input
                            v-if="searchShowSets.SaleOrderCode.IsShow"
                            class="search-item"
                            size="small"
                            style="width: 180px"
                            v-model="searchData.SaleOrderCode"
                            :placeholder="searchShowSets.SaleOrderCode.Placeholder"
                            @keyup.enter.native="handleSearch"
                        ></el-input>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.PayType.IsShow">
                            {{ searchShowSets.PayType.Title }}
                        </div>
                        <div class="search-item" v-if="searchShowSets.PayType.IsShow">
                            <el-select class="search-item" size="small" v-model="searchData.PayType" multiple collapse-tags clearable @keyup.enter.native="handleSearch">
                                <el-option v-for="item in payWayList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.State.IsShow">
                            {{ searchShowSets.State.Title }}
                        </div>
                        <div class="search-item" v-if="searchShowSets.State.IsShow">
                            <el-select class="search-item" size="small" v-model="searchData.State" @keyup.enter.native="handleSearch">
                                <el-option v-for="item in stateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.DeliveryStat.IsShow">
                            {{ searchShowSets.DeliveryStat.Title }}
                        </div>
                        <div class="search-item" v-if="searchShowSets.DeliveryStat.IsShow">
                            <el-select class="search-item" size="small" v-model="searchData.DeliveryStat" @keyup.enter.native="handleSearch">
                                <el-option v-for="item in deliveryStateList" :key="item.Value" :label="item.Text" :value="item.Value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.SId.IsShow">
                            {{ searchShowSets.SId.Title }}
                        </div>
                        <div class="search-item" v-if="searchShowSets.SId.IsShow">
                            <el-select class="search-item" size="small" v-model="searchData.SId" @keyup.enter.native="handleSearch">
                                <el-option v-for="item in SIdList" :key="item.EmployeeId" :label="item.EmployeeName" :value="item.EmployeeId"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="flex">
                        <div class="search-name" v-if="searchShowSets.CreateTime.IsShow">
                            {{ searchShowSets.CreateTime.Title }}
                        </div>
                        <i v-if="searchShowSets.CreateTime.IsShow" class="el-icon-date search-name time-btn" @click="timeVisible = true"></i>
                    </div>
                    <div class="flex">
                        <el-button size="small" icon="el-icon-search" class="search-btn btn-primary" @click="handleSearch">查询</el-button>
                        <el-button size="small" icon="el-icon-refresh" class="search-btn btn-primary" @click="resetSearch">重置</el-button>
                        <el-button size="small" icon="el-icon-setting" type="primary" class="search-btn" @click="showSearchSetDialog()">搜索设置</el-button>
                        <el-button size="small" icon="el-icon-printer" class="search-btn btn-primary" @click="print()" v-if="permission.print">{{ permission.print }}</el-button>
                        <el-button size="small" icon="el-icon-s-data" class="search-btn btn-primary" @click="showCount">合计</el-button>
                    </div>
                </div>
            </div>
            <div>
                <el-card class="box-card">
                    <div class="data-count">
                        <div class="data-item">
                            <p>
                                <el-tooltip effect="dark" placement="bottom">
                                    <div slot="content">采购总计 = 采购总额 + 总运费</div>
                                    <span>
                                        <i class="el-icon-warning-outline" style="color: orange; margin-right: 5px"></i>
                                    </span> </el-tooltip
                                >采购总计
                            </p>
                            <p>￥{{ statData.orderTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购总额</p>
                            <p>￥{{ statData.purTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>采购商品总数</p>
                            <p>{{ statData.purGoodsTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>运费总计</p>
                            <p>￥{{ statData.transTotal }}</p>
                        </div>
                        <div class="data-item">
                            <p>已付总额</p>
                            <p style="color: green; font-size: 16px">￥{{ statData.paidTotal }}</p>
                        </div>
                        <div class="data-item border-right-none">
                            <p>待付总额</p>
                            <p style="color: red; font-size: 16px">￥{{ statData.unPaidTotal }}</p>
                        </div>
                    </div>
                </el-card>
            </div>
            <div class="table-ctn purpay-table">
                <el-table
                    :header-cell-style="{ background: '#F2F6FC' }"
                    :data="tableData"
                    ref="multipleTable"
                    @selection-change="handleSelectionChange"
                    border
                    style="width: 100%"
                    @cell-dblclick="handleDBClick"
                    :tableCode="tableCode"
                    :row-key="getRowKeys"
                >
                    <el-table-column type="selection" reserve-selection width="55"></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.OrderCode.IsShow"
                        :width="columnShowSets.OrderCode.Width > 0 ? columnShowSets.OrderCode.Width + 'px' : '200px'"
                        :label="columnShowSets.OrderCode.ColumnName"
                        prop="OrderCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <el-badge :value="scope.row.ApplyCount + '条待确认'" class="mark" type="danger" v-if="scope.row.ApplyCount > 0">
                                {{ scope.row.OrderCode }}
                            </el-badge>
                            {{ scope.row.ApplyCount > 0 ? '' : scope.row.OrderCode }}
                        </template>
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.EntpCusName.IsShow"
                        :min-width="columnShowSets.EntpCusName.Width > 0 ? columnShowSets.EntpCusName.Width + 'px' : '200px'"
                        :label="columnShowSets.EntpCusName.ColumnName"
                        prop="EntpCusName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="Sources"
                        v-if="columnShowSets.Sources.IsShow"
                        :min-width="columnShowSets.Sources.Width > 0 ? columnShowSets.Sources.Width + 'px' : '120px'"
                        :label="columnShowSets.Sources.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.SaleOrderCode.IsShow"
                        :width="columnShowSets.SaleOrderCode.Width > 0 ? columnShowSets.SaleOrderCode.Width + 'px' : '170px'"
                        :label="columnShowSets.SaleOrderCode.ColumnName"
                        prop="SaleOrderCode"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <!-- <el-button @click="gotoSalesDetails(scope.row)" type="text">{{ scope.row.SaleOrderCode }}</el-button> -->
                            <el-button @click.native.stop="copyCode(scope.row)" title="单击单号复制，双击查看详情" type="text">{{ scope.row.SaleOrderCode }}</el-button>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="PayTypeName"
                        v-if="columnShowSets.PayTypeName.IsShow"
                        :min-width="columnShowSets.PayTypeName.Width > 0 ? columnShowSets.PayTypeName.Width + 'px' : '100px'"
                        :label="columnShowSets.PayTypeName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.PaymentStateName.IsShow"
                        :width="columnShowSets.PaymentStateName.Width > 0 ? columnShowSets.PaymentStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.PaymentStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.PaymentStateName == '已完成付款'" class="c-active">{{ scope.row.PaymentStateName }}</i>
                            <i v-else>{{ scope.row.PaymentStateName }}</i></template
                        >
                    </el-table-column>
                    <el-table-column
                        v-if="columnShowSets.InWarehouseStateName.IsShow"
                        :width="columnShowSets.InWarehouseStateName.Width > 0 ? columnShowSets.InWarehouseStateName.Width + 'px' : '100px'"
                        :label="columnShowSets.InWarehouseStateName.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <i v-if="scope.row.InWarehouseStateName == '已入仓'" class="out-active">{{ scope.row.InWarehouseStateName }}</i>
                            <i v-else>{{ scope.row.InWarehouseStateName }}</i></template
                        >
                    </el-table-column>
                    <el-table-column
                        prop="OrderAmount"
                        v-if="columnShowSets.OrderAmount.IsShow"
                        :min-width="columnShowSets.OrderAmount.Width > 0 ? columnShowSets.OrderAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.OrderAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="PurCount"
                        v-if="columnShowSets.PurCount.IsShow"
                        :min-width="columnShowSets.PurCount.Width > 0 ? columnShowSets.PurCount.Width + 'px' : '100px'"
                        :label="columnShowSets.PurCount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="ShipAmount"
                        v-if="columnShowSets.ShipAmount.IsShow"
                        :min-width="columnShowSets.ShipAmount.Width > 0 ? columnShowSets.ShipAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.ShipAmount.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        v-if="columnShowSets.CalcAmount.IsShow"
                        :width="columnShowSets.CalcAmount.Width > 0 ? columnShowSets.CalcAmount.Width + 'px' : '100px'"
                        :label="columnShowSets.CalcAmount.ColumnName"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">{{ (scope.row.OrderAmount + scope.row.ShipAmount).toFixed(2) }}</template>
                    </el-table-column>
                    <el-table-column
                        prop="Paid"
                        v-if="columnShowSets.Paid.IsShow"
                        :min-width="columnShowSets.Paid.Width > 0 ? columnShowSets.Paid.Width + 'px' : '100px'"
                        :label="columnShowSets.Paid.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="SName"
                        v-if="columnShowSets.SName.IsShow"
                        :min-width="columnShowSets.SName.Width > 0 ? columnShowSets.SName.Width + 'px' : '80px'"
                        :label="columnShowSets.SName.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="CreateTime"
                        sortable
                        v-if="columnShowSets.CreateTime.IsShow"
                        :min-width="columnShowSets.CreateTime.Width > 0 ? columnShowSets.CreateTime.Width + 'px' : '160px'"
                        :label="columnShowSets.CreateTime.ColumnName"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column fixed="right" label="操作" :autoWidth="true" :isCanSet="true">
                        <template slot-scope="scope">
                            <el-button
                                v-if="permission.purchasesOrderPaymentFunc && scope.row.ApplyCount > 0"
                                :title="permission.purchasesOrderPaymentFunc"
                                size="mini"
                                type="text"
                                @click="add('cpayment', scope.row)"
                                >{{ permission.purchasesOrderPaymentFunc }}</el-button
                            >
                            <el-button
                                v-else-if="permission.editAndConfirm && scope.row.IsCanPay && scope.row.ApplyCount > 0"
                                :title="permission.editAndConfirm"
                                size="mini"
                                type="text"
                                @click="add('cpayment', scope.row)"
                                >{{ permission.editAndConfirm }}</el-button
                            >
                            <!--当订单无申请收付款记录时弹窗完成付款-->
                            <el-button
                                v-else-if="permission.editAndConfirm && scope.row.IsCanPay && scope.row.ApplyCount == 0"
                                :title="permission.editAndConfirm"
                                size="mini"
                                type="text"
                                @click="finishAndEditReceipt(scope.row)"
                                >{{ permission.editAndConfirm }}</el-button
                            >
                            <el-button
                                v-if="permission.stateBack && scope.row.IsCanStateBack"
                                :title="permission.stateBack"
                                size="mini"
                                type="text"
                                style="color: red"
                                @click="stateBack(scope.row)"
                                >{{ permission.stateBack }}</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pagination-ctn">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page.sync="searchData.page"
                    :page-sizes="[commonPageSize, 20, 30, 40, 50]"
                    :page-size="searchData.limit"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="tableDataLength"
                    v-if="tableDataLength != 0"
                ></el-pagination>
            </div>
            <el-dialog :close-on-click-modal="false" title="合计" @close="closeDialog" :visible.sync="statisticsVisible" width="500px">
                <div class="dialog-content" v-if="statisticsVisible">
                    <statistics :countData="multipleSelection" type="buy"></statistics>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="创建时间" :visible.sync="timeVisible" width="800px">
                <div class="dialog-content" v-if="timeVisible">
                    <timePicker @timerSearch="timerSearch" :start="this.searchData.StartDate" :end="this.searchData.EndDate"></timePicker>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="打印" :visible.sync="dialogVisible" width="1000px">
                <div class="dialog-content" v-if="dialogVisible">
                    <printContent @closeDialog="closeDialog" :printIds="idList"></printContent>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="自定义搜索条件展示设置" @close="closeDialog" :visible.sync="searchSetVisible" append-to-body width="600px">
                <div class="dialog-content" v-if="searchSetVisible">
                    <searchSets :tableCode="tableCode" @closeDialog="closeDialog"></searchSets>
                </div>
            </el-dialog>
            <el-dialog :close-on-click-modal="false" title="完成收款" :visible.sync="finishVisible" width="1000px">
                <div class="dialog-content" v-if="finishVisible">
                    <finishReceiptOrPayment @closeFinish="closeFinish" :finishData="finishData" :type="1"></finishReceiptOrPayment>
                </div>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import elTableColumn from '@/components/common/chjtablecolumn';
import breadcrumb from '@/components/common/breadcrumb';
import statistics from '@/components/common/statistics.vue';
import timePicker from '@/components/common/timePicker';
import searchSets from '@/components/common/searchSets.vue';
import finishReceiptOrPayment from '@/components/business/revenue/finishReceiptOrPayment';
import Vue from 'vue';
import mixin from '@/mixins/mixin';
import pageLimitMixin from '@/mixins/pageLimitMixin';
export default {
    mixins: [mixin, pageLimitMixin],
    name: '',
    props: ['type'],
    components: {
        statistics,
        timePicker,
        breadcrumb,
        elTableColumn,
        searchSets,
        finishReceiptOrPayment
    },
    data() {
        let userMsg = this.$util.getLocalStorage('userMsg');
        return {
            tableCode: 'PurOrderPayment',
            userMsg: userMsg,
            searchSetVisible: false,
            timeVisible: false,
            statisticsVisible: false,
            multipleSelection: null,
            dialogVisible: false,
            dataIndex: 1,
            tableData: [],
            idList: [],
            tableDataLength: 0,
            permission: {},
            stateList: [
                { Text: '全部', Value: '' },
                { Text: '未付款', Value: '5' },
                { Text: '已付定金', Value: '10' },
                { Text: '已完成付款', Value: '15' }
            ],
            deliveryStateList: [
                { Text: '全部', Value: '' },
                { Text: '未入仓', Value: '5' },
                { Text: '部分入仓', Value: '10' },
                { Text: '已入仓', Value: '15' }
            ],
            payWayList: [],
            searchData: {
                PayType: [],
                Keyword: '',
                Sources: '',
                State: '5',
                OrderCode: '',
                SaleOrderCode: '',
                StartDate: '',
                DeliveryStat: '',
                SId: '',
                EndDate: '',
                page: 1,
                limit: 15
            },
            statData: {
                orderTotal: 0,
                purTotal: 0,
                transTotal: 0,
                purGoodsTotal: 0,
                paidTotal: 0,
                unPaidTotal: 0
            },
            PayTypeList: [],
            SIdList: [],
            sourceList: [],
            columnShowSets: {
                OrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                EntpCusName: { ColumnName: '', IsShow: false, Width: 0 },
                Sources: { ColumnName: '', IsShow: false, Width: 0 },
                SaleOrderCode: { ColumnName: '', IsShow: false, Width: 0 },
                PayTypeName: { ColumnName: '', IsShow: false, Width: 0 },
                OrderAmount: { ColumnName: '', IsShow: false, Width: 0 },
                PurCount: { ColumnName: '', IsShow: false, Width: 0 },
                ShipAmount: { ColumnName: '', IsShow: false, Width: 0 },
                PaymentStateName: { ColumnName: '', IsShow: false, Width: 0 },
                CalcAmount: { ColumnName: '', IsShow: false, Width: 0 },
                InWarehouseStateName: { ColumnName: '', IsShow: false, Width: 0 },
                Paid: { ColumnName: '', IsShow: false, Width: 0 },
                SName: { ColumnName: '', IsShow: false, Width: 0 },
                CreateTime: { ColumnName: '', IsShow: false, Width: 0 }
            },
            searchShowSets: {
                EntpCusName: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                OrderCode: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                Sources: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                SaleOrderCode: {
                    Title: '',
                    IsShow: false,
                    SortNum: 0,
                    Placeholder: ''
                },
                PayType: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                State: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                DeliveryStat: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                SId: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' },
                CreateTime: { Title: '', IsShow: false, SortNum: 0, Placeholder: '' }
            },
            // 用于供应商列表，分页搜索
            supplierOptions: [],
            supplierForm: {
                Page: 1,
                Limit: 10,
                stopLoad: false,
                key: ''
            },
            finishVisible: false,
            finishData: { allMoney: 0, orderId: '', payType: '', shareCost: 0 },
            clickTimer: null,  //添加一个计时器
        };
    },
    mounted() {
        let that = this;
        that.initSearchSelectData();

        that.getTableData();
        that.searchSupplier();
        that.$util.setEnterEvent(that, that.$route.fullPath);
        that.permission = that.$util.getPermission('purchasesOrderPayment');

        Vue.component('printContent', function (resolve) {
            that.$util.getPrintComponents(1).then(data => {
                if (data) {
                    require(['@/components/printModels/' + data], resolve);
                } else {
                    require(['@/components/printModels/printPurchases'], resolve);
                }
            });
        });
    },
    created() {
        if (this.tableCode) {
            this.getSetsData();
            this.getSearchCrtSetsData();
        }
    },
    activated() {
        this.doLayout('multipleTable');
    },
    watch: {
        NeedRefresh(value) {
            if (value.NeedRefresh) {
                this.getTableData();
            }
        }
    },
    computed: {
        NeedRefresh() {
            return this.$route.query;
        }
    },
    methods: {
        // 记录每行的key值
        getRowKeys(row) {
            return row.EntpCusPOId;
        },
        // 供应商列表，搜索
        async searchSupplier(key) {
            if (![undefined].includes(key)) {
                this.supplierForm.Page = 1;
                this.supplierForm.stopLoad = false;
                this.supplierForm.key = key;
                this.supplierOptions = [];
            }
            if (this.supplierForm.stopLoad) return;
            const data = await this.$util.searchSupplier(this.supplierForm.key, this.supplierForm.Page, this.supplierForm.Limit);
            if (data) {
                if (!data) return;
                this.supplierForm.stopLoad = data.length < this.supplierForm.Limit;
                this.supplierOptions = [...this.supplierOptions, ...data];
            }
        },
        // 供应商列表，加载更多
        searchSupplierLoad() {
            this.supplierForm.Page += 1;
            this.searchSupplier();
        },
        initSearchSelectData() {
            //可以把这些常用的数据放到缓存里面
            this.getPay();
            this.getSIdList();
        },
        getSIdList() {
            this.$util.getSIdList().then(data => {
                this.SIdList = data;
            });
        },
        //  结算方式
        getPay() {
            this.$util.getPay().then(data => {
                this.payWayList = data;
            });
        },
        querySource(queryString, cb) {
            this.$util.searchPurchaseOrderSourceList(queryString).then(data => {
                let sourceList = [];
                for (let i in data) {
                    sourceList.push({
                        value: data[i]
                    });
                }
                cb(sourceList);
            });
        },
        timerSearch(timer) {
            this.timeVisible = false;
            this.searchData.StartDate = timer.start;
            this.searchData.EndDate = timer.end;
            this.handleSearch();
        },
        // 显示统计
        showCount() {
            if (this.multipleSelection) {
                this.statisticsVisible = true;
            } else {
                this.$util.warningMsg('请至少选择一条数据');
            }
        },
        closeDialog() {
            this.$refs.multipleTable.clearSelection();
            this.multipleSelection = null;
            this.statisticsVisible = false;
            this.dialogVisible = false;
            this.searchSetVisible = false;
        },
        // 勾选统计
        handleSelectionChange(val) {
            this.multipleSelection = val;
            let idList = [];
            for (let i = 0; i < val.length; i++) {
                idList.push({
                    id: val[i].EntpCusPOId,
                    orderCode: val[i].OrderCode
                });
            }
            this.idList = idList;
        },
        // 获取采购付款列表
        getTableData() {
            this.$util
                .axiosPost({
                    url: '/api/RevenueManagement/GetPurchaseOrderList',
                    data: this.searchData
                })
                .then(res => {
                    let data = res.data;
                    if (!data) data = {};
                    this.statData.orderTotal = data.OrderTotal;
                    this.statData.purTotal = data.PurTotal;
                    this.statData.purGoodsTotal = data.PurGoodsTotal;
                    this.statData.transTotal = data.TransTotal;
                    this.statData.paidTotal = data.PaidTotal;
                    this.statData.unPaidTotal = data.UnPaidTotal;
                    this.tableData = data.PurchaseOrderList;
                    this.tableDataLength = res.count;
                });
        },
        resetSearch() {
            this.searchData = {
                PayType: [],
                Keyword: '',
                Sources: '',
                State: '',
                OrderCode: '',
                SaleOrderCode: '',
                StartDate: '',
                DeliveryStat: '',
                SId: '',
                EndDate: '',
                page: 1,
                limit: this.commonPageSize
            };
            this.searchSupplier('');
            this.$refs.multipleTable.clearSelection();
        },
        // 跳转编辑
        add(type, item) {
            let id = item ? item.EntpCusPOId : '';
            this.$router.push(`/financeManage/purchasesOrder/payment/confirmPayment?action=${type}&id=${id}`);
        },
        finishAndEditReceipt(item) {
            this.finishData.allMoney = item.SurplusMoney;
            this.finishData.orderId = item.EntpCusPOId;
            this.finishData.payType = item.PayType;
            this.finishData.shareCost = item.ShipAmount;
            this.finishVisible = true;
        },
        closeFinish(edit) {
            this.finishVisible = false;
            if (edit) {
                this.getTableData();
            }
        },
        handleSearch() {
            this.$refs.multipleTable.clearSelection();
            this.searchData.page = 1;
            this.getTableData();
        },
        handleSizeChange(val) {
            this.searchData.page = 1;
            this.searchData.limit = val;
            this.getTableData();
        },
        handleCurrentChange(val) {
            this.searchData.page = val;
            this.getTableData();
        },
        //表单双击事件
        handleDBClick(row, column, cell, event) {
            clearTimeout(this.clickTimer); //清除未执行的定时器
            if (row) {
                if(column.property == "SaleOrderCode"&&row.SaleOrderCode){
                    this.gotoSalesDetails(row)
                }
                else
                    this.add('see', row);
            }
            event.stopPropagation()            
        },
        stateBack(item) {
            let that = this;
            if (item.EntpCusPOId) {
                that.$confirm('您确定要将完成付款的状态回退成未完成付款状态吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    center: false
                })
                    .then(() => {
                        that.$util
                            .axiosPost({
                                url: '/api/EntpPurchaseOrder/PurchaseOrderStateBack',
                                data: {
                                    orderId: item.EntpCusPOId,
                                    userId: that.userMsg.EmployeeId
                                }
                            })
                            .then(res => {
                                that.$util.successMsg('状态回退成功');
                                that.getTableData();
                            })
                            .catch(() => {});
                    })
                    .catch(() => {});
            } else {
                that.$util.warningMsg('订单信息异常，请刷新后重新操作');
            }
        },
        // 打印
        print() {
            if (this.idList.length != 1) {
                this.$util.warningMsg('请选择一张采购单打印');
                return;
            }
            this.dialogVisible = true;
        },
        gotoSalesDetails(row) {
            this.$router.push(`/salesManage/salesOrder/edit_v2?type=1&id=${row.SaleOrderId}&fromLv2=revenue_p`);
        },
        getSetsData() {
            this.$util.getTableSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.ColumnCode) {
                        case 'OrderCode':
                            this.columnShowSets.OrderCode.IsShow = item.IsShow;
                            this.columnShowSets.OrderCode.Width = item.Width;
                            this.columnShowSets.OrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'EntpCusName':
                            this.columnShowSets.EntpCusName.IsShow = item.IsShow;
                            this.columnShowSets.EntpCusName.Width = item.Width;
                            this.columnShowSets.EntpCusName.ColumnName = item.ColumnName;
                            break;
                        case 'Sources':
                            this.columnShowSets.Sources.IsShow = item.IsShow;
                            this.columnShowSets.Sources.Width = item.Width;
                            this.columnShowSets.Sources.ColumnName = item.ColumnName;
                            break;
                        case 'SaleOrderCode':
                            this.columnShowSets.SaleOrderCode.IsShow = item.IsShow;
                            this.columnShowSets.SaleOrderCode.Width = item.Width;
                            this.columnShowSets.SaleOrderCode.ColumnName = item.ColumnName;
                            break;
                        case 'PayTypeName':
                            this.columnShowSets.PayTypeName.IsShow = item.IsShow;
                            this.columnShowSets.PayTypeName.Width = item.Width;
                            this.columnShowSets.PayTypeName.ColumnName = item.ColumnName;
                            break;
                        case 'PaymentStateName':
                            this.columnShowSets.PaymentStateName.IsShow = item.IsShow;
                            this.columnShowSets.PaymentStateName.Width = item.Width;
                            this.columnShowSets.PaymentStateName.ColumnName = item.ColumnName;
                            break;
                        case 'InWarehouseStateName':
                            this.columnShowSets.InWarehouseStateName.IsShow = item.IsShow;
                            this.columnShowSets.InWarehouseStateName.Width = item.Width;
                            this.columnShowSets.InWarehouseStateName.ColumnName = item.ColumnName;
                            break;
                        case 'OrderAmount':
                            this.columnShowSets.OrderAmount.IsShow = item.IsShow;
                            this.columnShowSets.OrderAmount.Width = item.Width;
                            this.columnShowSets.OrderAmount.ColumnName = item.ColumnName;
                            break;
                        case 'PurCount':
                            this.columnShowSets.PurCount.IsShow = item.IsShow;
                            this.columnShowSets.PurCount.Width = item.Width;
                            this.columnShowSets.PurCount.ColumnName = item.ColumnName;
                            break;
                        case 'ShipAmount':
                            this.columnShowSets.ShipAmount.IsShow = item.IsShow;
                            this.columnShowSets.ShipAmount.Width = item.Width;
                            this.columnShowSets.ShipAmount.ColumnName = item.ColumnName;
                            break;
                        case 'CalcAmount':
                            this.columnShowSets.CalcAmount.IsShow = item.IsShow;
                            this.columnShowSets.CalcAmount.Width = item.Width;
                            this.columnShowSets.CalcAmount.ColumnName = item.ColumnName;
                            break;
                        case 'Paid':
                            this.columnShowSets.Paid.IsShow = item.IsShow;
                            this.columnShowSets.Paid.Width = item.Width;
                            this.columnShowSets.Paid.ColumnName = item.ColumnName;
                            break;
                        case 'SName':
                            this.columnShowSets.SName.IsShow = item.IsShow;
                            this.columnShowSets.SName.Width = item.Width;
                            this.columnShowSets.SName.ColumnName = item.ColumnName;
                            break;
                        case 'CreateTime':
                            this.columnShowSets.CreateTime.IsShow = item.IsShow;
                            this.columnShowSets.CreateTime.Width = item.Width;
                            this.columnShowSets.CreateTime.ColumnName = item.ColumnName;
                            break;
                    }
                });
            });
        },
        getSearchCrtSetsData() {
            this.$util.getSearchCrtSetsData(this.tableCode, true).then(data => {
                data.forEach(item => {
                    switch (item.SearchCode) {
                        case 'EntpCusName':
                            this.searchShowSets.EntpCusName.IsShow = item.IsShow;
                            this.searchShowSets.EntpCusName.Width = item.Width;
                            this.searchShowSets.EntpCusName.Placeholder = item.Placeholder;
                            this.searchShowSets.EntpCusName.Title = item.Title;
                            this.searchShowSets.EntpCusName.SortNum = item.SortNum;
                            break;
                        case 'OrderCode':
                            this.searchShowSets.OrderCode.IsShow = item.IsShow;
                            this.searchShowSets.OrderCode.Width = item.Width;
                            this.searchShowSets.OrderCode.Placeholder = item.Placeholder;
                            this.searchShowSets.OrderCode.Title = item.Title;
                            this.searchShowSets.OrderCode.SortNum = item.SortNum;
                            break;
                        case 'Sources':
                            this.searchShowSets.Sources.IsShow = item.IsShow;
                            this.searchShowSets.Sources.Width = item.Width;
                            this.searchShowSets.Sources.Placeholder = item.Placeholder;
                            this.searchShowSets.Sources.Title = item.Title;
                            this.searchShowSets.Sources.SortNum = item.SortNum;
                            break;
                        case 'SaleOrderCode':
                            this.searchShowSets.SaleOrderCode.IsShow = item.IsShow;
                            this.searchShowSets.SaleOrderCode.Width = item.Width;
                            this.searchShowSets.SaleOrderCode.Placeholder = item.Placeholder;
                            this.searchShowSets.SaleOrderCode.Title = item.Title;
                            this.searchShowSets.SaleOrderCode.SortNum = item.SortNum;
                            break;
                        case 'PayType':
                            this.searchShowSets.PayType.IsShow = item.IsShow;
                            this.searchShowSets.PayType.Width = item.Width;
                            this.searchShowSets.PayType.Placeholder = item.Placeholder;
                            this.searchShowSets.PayType.Title = item.Title;
                            this.searchShowSets.PayType.SortNum = item.SortNum;
                            break;
                        case 'State':
                            this.searchShowSets.State.IsShow = item.IsShow;
                            this.searchShowSets.State.Width = item.Width;
                            this.searchShowSets.State.Placeholder = item.Placeholder;
                            this.searchShowSets.State.Title = item.Title;
                            this.searchShowSets.State.SortNum = item.SortNum;
                            break;
                        case 'DeliveryStat':
                            this.searchShowSets.DeliveryStat.IsShow = item.IsShow;
                            this.searchShowSets.DeliveryStat.Width = item.Width;
                            this.searchShowSets.DeliveryStat.Placeholder = item.Placeholder;
                            this.searchShowSets.DeliveryStat.Title = item.Title;
                            this.searchShowSets.DeliveryStat.SortNum = item.SortNum;
                            break;
                        case 'SId':
                            this.searchShowSets.SId.IsShow = item.IsShow;
                            this.searchShowSets.SId.Width = item.Width;
                            this.searchShowSets.SId.Placeholder = item.Placeholder;
                            this.searchShowSets.SId.Title = item.Title;
                            this.searchShowSets.SId.SortNum = item.SortNum;
                            break;
                        case 'CreateTime':
                            this.searchShowSets.CreateTime.IsShow = item.IsShow;
                            this.searchShowSets.CreateTime.Width = item.Width;
                            this.searchShowSets.CreateTime.Placeholder = item.Placeholder;
                            this.searchShowSets.CreateTime.Title = item.Title;
                            this.searchShowSets.CreateTime.SortNum = item.SortNum;
                            break;
                    }
                });
            });
        },
        showSearchSetDialog() {
            this.searchSetVisible = true;
        },
        copyCode(row){
            let that=this;
            clearTimeout(that.clickTimer); //清除未执行的定时器
            that.clickTimer = setTimeout(function () {
                let inputNode = document.createElement('input')  // 创建input
                inputNode.value = row.SaleOrderCode // 赋值给 input 值
                document.body.appendChild(inputNode) // 插入进去
                inputNode.select() // 选择对象
                document.execCommand('Copy') // 原生调用执行浏览器复制命令
                inputNode.className = 'oInput'
                inputNode.style.display = 'none' // 隐藏
                that.$message.success('复制成功')
            }, 500);
        },        
    }
};
</script>
<style lang="less" scoped>
.data-count {
    padding: 5px;
    display: flex;
    .data-item {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 16.6%;
        border-right: 1px solid @border4Color;
        > p:nth-child(1) {
            margin-bottom: 5px;
        }
    }
}
.cell {
    .el-button {
        padding: 5px;
    }
}
.business-content-main {
    .search-ctn .search-item {
        margin-bottom: 0;
    }
}
</style>
<style lang="less">
.purpay-table {
    .el-table__row {
        td:nth-child(2) {
            .cell {
                overflow: visible;
            }
        }
    }
}
</style>
